/**
 * Routes où la barre de navigation mobile ne doit pas recouvrir
 * un CTA fixe (achat forfait, réservation, checkout, etc.).
 */
export function shouldHideBottomNav(pathname: string): boolean {
  if (pathname === '/messaging') return true;
  if (pathname === '/checkout') return true;

  // /pro/:slug/forfait/:forfaitSlug
  if (/^\/pro\/[^/]+\/forfait\/[^/]+$/.test(pathname)) return true;
  // /pro/:slug/book
  if (/^\/pro\/[^/]+\/book\/?$/.test(pathname)) return true;
  // /pro/:slug/abonnement/:planId
  if (/^\/pro\/[^/]+\/abonnement\/[^/]+$/.test(pathname)) return true;

  return false;
}
